<template>
  <div class="hello">
    <div class="filters container-fluid">
      <div class="search">
        <input @input="debouncedSearch" v-model="searchTerm" type="text" placeholder="Rechercher une affaire...">
        <label class="checkAffaire">
          <select @change="searchAffaires(currentPage)" v-model="selectedClient">
            <option value="">Tous les clients</option>
            <option v-for="client in clients" :key="client.id" :value="client.cocli">{{ client.nom }}</option>
          </select>
        </label>
      </div>
      <div v-if="nb_pages > 1" class="pagination">
        <div class="pagination-pages">
          <span>Page:</span>
          <select @change="searchAffaires(parseInt($event.target.value))">
            <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
          </select>
          <span>sur {{ nb_pages }}</span>
        </div>
      </div>
      <div class="infosFiltersSoldee">
        <div v-if="loggedInRole=='admin' || loggedInRole=='gestion' || loggedInRole=='production'" class="actionsAdmin">
          <RouterLink to="/affaires"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-archive-fill" viewBox="0 0 16 16">
          <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"/>
          </svg>Affaires en cours</RouterLink>
        </div>
      </div>
    </div>

    <!-- Barre de tri harmonisée -->
    <div class="sort-bar mb-3">
      <span class="">Trier par :</span>
      <button type="button" class="sort-btn" @click="handleColumnSort('naf')">
        N°Affaire
        <span v-if="sortColumn === 'naf'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('client')">
        Client
        <span v-if="sortColumn === 'client'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('qte')">
        Quantité
        <span v-if="sortColumn === 'qte'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('delais')">
        Délai
        <span v-if="sortColumn === 'delais'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
        </span>
      </button>
      <button type="button" class="sort-btn" @click="handleColumnSort('dispo')">
        Disponibilité
        <span v-if="sortColumn === 'dispo'">
          <svg v-if="sortDirection === 'asc'" width="10" height="10" viewBox="0 0 10 10"><path d="M5 2 L8 7 H2 Z"/></svg>
          <svg v-else width="10" height="10" viewBox="0 0 10 10"><path d="M5 8 L2 3 H8 Z"/></svg>
        </span>
      </button>
    </div>

    <div class="tabC">
      <div class="row">
        <template v-if="affaires.length === 0">
          <div class="no-articles col-12">Pas d'affaires disponibles.</div>
        </template>
        <template v-else>
          <RouterLink v-for="affaire in affaires" :key="affaire.id" :to="getAffaireLink(affaire)" class="col-xl-3 col-lg-4 col-md-6 col-12 affaire-card-link" style="display: flex;">
            <div v-if="affaire.naf.trim() !== ''" class="affaire-card" style="width: 100%;">
              <div class="card-header">
                <div class="code-affaire">
                  <div class="top">
                    <strong>N°AFFAIRE : </strong>{{ affaire.naf }}
                  </div>
                  <div class="bottom">
                    <span>{{ affaire.cocde }}</span>
                  </div>
                </div>
                <!-- Si tu veux la pastille équipe, tu peux la remettre ici -->
              </div>
              <div class="card-body">
                <div class="content">
                  <div class="card-title">
                    <div class="desa1">{{ affaire.desa }}</div>
                    <div class="desa2">{{ affaire.desa2 }}</div>
                    <div class="desa3">{{ affaire.desa3 }}</div>
                  </div>
                  <div class="card-infos">
                    <span class="info-chip">client : <strong>{{ affaire.client }}</strong></span>
                    <span class="info-chip">quantité : <strong>{{ affaire.qte }}</strong></span>
                    <span class="info-chip">délai : <strong><span :class="{'expired': isDatePassed(affaire.delais), 'nonExpired': !isDatePassed(affaire.delais)}">{{ formatDate(affaire.delais) }}</span></strong></span>
                  </div>
                  <div v-if="getDisponibiliteByNAF(affaire.naf) !== null" class="progress-bar-affaire mt-2">
                    <div class="progress-bg">
                      <div class="progress-fill" :style="{ width: getDisponibiliteByNAF(affaire.naf) + '%', background: getDisponibiliteByNAF(affaire.naf) >= 80 ? '#c2e5f5' : getDisponibiliteByNAF(affaire.naf) >= 40 ? '#ffa600' : 'red' }"></div>
                      <span class="progress-label">{{ getDisponibiliteByNAF(affaire.naf) }}%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </RouterLink>
        </template>
      </div>
    </div>

    <div v-if="nb_pages > 1" class="pagination container mt-4">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchAffaires(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>


      <!-- Popup -->
    <div v-if="popupOpen" class="popup" >
      <!-- Popup content -->
      <div class="popup-content listPopup">
        <!-- Popup header -->
        <div class="popup-header">
          <h2>Relier ou délier un ou plusieurs utilisateurs à cette affaire</h2>
          <a class="close-button" @click="closePopup">&times;</a>
        </div>

        <!-- Popup body -->
        <div class="popup-body">
          <form @submit.prevent="submit">
            <div>
              <label class="mb-2">Lier ou délier un ou plusieurs utilisateurs :</label>
              <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                {{ confirmationMessage }}
              </div>
              <div class="containerList">
                <div class="line" v-for="user in users" :key="user.id">
                  <label class="check">
                    <input type="checkbox" :value="user.email" v-model="utilisateursSelectionnes" :checked="utilisateursSelectionnes.includes(user.email)">
                    {{ user.nom }} {{ user.prenom }}
                  </label>
                </div>

              </div>
            
            </div>
            <div>
              <input type="hidden" id="affaire" v-model="aff" required>
            </div>
            <button type="submit">Envoyer</button>
          </form>
        </div>
      </div>
    </div>


      <!-- Popup -->
      <div v-if="popupOpen2" class="popup" >
        <!-- Popup content -->
        <div class="popup-content listPopup">
          <!-- Popup header -->
          <div class="popup-header">
            <h2>Relier ou délier un ou plusieurs utilisateurs à ces affaires</h2>
            <button class="close-button" @click="closePopupMasse">&times;</button>
          </div>
  
          <!-- Popup body -->
          <div class="popup-body">
            <form @submit.prevent="submit2">
              <div>
                <label class="mb-2">Lier ou délier un ou plusieurs utilisateurs :</label>
                <div v-if="confirmationMessage" class="alert alert-success" role="alert">
                  {{ confirmationMessage }}
                </div>
                <div class="containerList">
                  <div class="line" v-for="user in users" :key="user.id">
                    <label class="check">
                      <input type="checkbox" :value="user.email" v-model="utilisateursSelectionnes" :checked="utilisateursSelectionnes.includes(user.email)">
                      {{ user.nom }} {{ user.prenom }}
                    </label>
                  </div>
  
                </div>
              
              </div>
              <div>
                <input type="hidden" id="affaire" v-model="aff" required>
              </div>
              <button type="submit">Envoyer</button>
            </form>
          </div>
        </div>
      </div>
  </div>


 
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import Chart from 'chart.js/auto';




export default {
  data() {
    return {
      affaires: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      selectedFilter: '',
      selectedClient: 'Toutes les commandes',
      isLoading: false,
      confirmationMessage: '',
      errorMessage: '',
      popupOpen: false,
      popupOpen2: false,
      aff: '',
      utilisateursSelectionnes: [],
      infosAffaires: [],
      infosAffaires1: [],
      loggedInRole: null,
      loggedInEmail: null,
      loggedInPrenom: null,
      loggedInNom: null,
      users: [],
      sortColumn: '',
      sortDirection: 'asc',
      selectAll: false,
      selectedItems: [],
      clients: [],
      listActions: '',
      dataDispo: [],
      loading: true,
      searchTimeout: null,
      cancelTokenSource: null,
      requestId: 0,
    }
  },
  mounted() {

    
    // Récupération des données de l'API PHP
    this.currentPage = parseInt(this.$route.query.page) || 1;
    this.searchTerm = this.$route.query.searchTerm || '';
    this.selectedFilter = this.$route.query.selectedFilter || '';
    this.selectedClient = this.$route.query.selectedClient || '';
    this.sortColumn = this.$route.query.sortColumn || '';
    this.sortDirection = this.$route.query.sortDirection || '';
    
    this.searchAffaires(this.currentPage);
    
    this.getInfosAffaires();
    this.getInfosAffairesProduction();

    axios.get('https://www.simef.fr/espace-client/api/getClientsSoldees.php')
    .then(response => {
      this.clients = response.data;
    })
    .catch(error => {
      console.error(error);
    }); 



    axios.post('https://www.simef.fr/espace-client/api/getDispo.php', {})
    .then(response => {
      // Traiter les données reçues
      const processedResults = response.data.map(item => {
        const naf = item.naf;
        const disponibilite = item.disponibilite;
        return { naf, disponibilite };
      });

      // Affecter les données traitées à votre variable dataDispo
      this.dataDispo = processedResults;

      // Afficher les données traitées
      console.log('Données traitées :', this.dataDispo);
      
      this.loading = false;
    })
    .catch(error => {
      console.log('Erreur :', error);
    });




      
  },
  created() {
  
    const email = VueCookies.get('email')
    if (email) {
      this.loggedInEmail = email
    }
    const role = VueCookies.get('role')
    if (role) {
      this.loggedInRole = role
    }

    
    
    this.getInfosAffairesProduction();

 
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';
      this.selectedClient = to.query.selectedClient || '';
      this.sortColumn = to.query.sortColumn || '';
      this.sortDirection = to.query.sortDirection || '';
      
      this.searchAffaires(this.currentPage);
    }
    
  },
  computed: {

  },
  methods: {
    debouncedSearch() {
      // Annuler le timeout précédent
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Créer un nouveau timeout
      this.searchTimeout = setTimeout(() => {
        this.searchAffaires(this.currentPage);
      }, 300); // 300ms de délai
    },
    
    searchAffaires(page) {
      // Annuler la requête précédente si elle existe
      if (this.cancelTokenSource) {
        this.cancelTokenSource.cancel('Nouvelle recherche lancée');
      }
      
      // Créer un nouveau token d'annulation
      this.cancelTokenSource = axios.CancelToken.source();
      
      // Incrémenter l'ID de requête
      this.requestId++;
      const currentRequestId = this.requestId;

      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/getAffairesSoldees.php', {
        page: page,
        searchTerm: this.searchTerm,
        selectedClient: this.selectedClient,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      }, {
        cancelToken: this.cancelTokenSource.token
      })
      .then(response => {
        // Vérifier que c'est bien la dernière requête
        if (currentRequestId === this.requestId) {
          // Rediriger vers une page de confirmation d'inscription
          this.affaires = response.data.affaires;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;
        }
      })
      .catch(error => {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
      })
      .finally(() => {
        // Ne masquer le loader que si c'est la dernière requête
        if (currentRequestId === this.requestId) {
          this.isLoading = false;
        }
      });

      this.$router.push({
      query: {
        page: page,
        searchTerm: this.searchTerm,
        selectedClient: this.selectedClient,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      }

      });
        
     
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    isDatePassed(date) {
      const currentDate = new Date(); // Get the current date and time
      currentDate.setHours(0, 0, 0, 0); // Set the time to midnight
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);
      const targetDate = new Date(year, month - 1, day); // Create a valid date object

      // Compare the target date with the current date
      return targetDate < currentDate;
    },
    solderAffaire(affaire) {
      if (confirm("Êtes-vous sûr de solder cette affaire ?")) {
        axios
          .post('https://www.simef.fr/espace-client/api/solderAffaire.php', {
            naf: affaire.naf,
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            // Remove the archived demande from the demandes array
            const index = this.affaires.indexOf(affaire);
            if (index !== -1) {
              this.affaires.splice(index, 1);
            }
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    solderAffaire2() {
      if (confirm("Êtes-vous sûr de solder ces affaires ?")) {
        axios
          .post('https://www.simef.fr/espace-client/api/solderAffaires.php', {
            selectedItems: this.selectedItems,
          })
          .then(response => {
            this.confirmationMessage = response.data.success;
            // Remove the archived demande from the demandes array
            this.affaires = this.affaires.filter(affaire => !this.selectedItems.includes(affaire.naf));
          })
          .catch(error => {
            console.log(error);
          });
      }
    },
    getAffaireLink(affaire) {
      // Create the base URL

      var affaireName =  affaire.desa.replace(/\//g, "%2F").trim();
      var affaireName2 = affaire.desa2.replace(/\//g, "%2F").trim();
      var affaireName3 =  affaire.desa3.replace(/\//g, "%2F").trim();
      var client =  affaire.client.replace(/\//g, "%2F").trim();

      if (affaireName === '') {
        affaireName = 'empty';
      }
      if (affaireName2 === '') {
        affaireName2 = 'empty';
      }
      if (affaireName3 === '') {
        affaireName3 = 'empty';
      }
      if (client === '') {
        client = 'empty';
      }



      let url = '/affaire-soldee/' + affaireName + '/' + affaireName2 + '/' + affaireName3 + '/' + affaire.naf  + '/' + client;

      // Add the optional parameters if they are not empty
      // Vérifie si la chaîne est vide après les remplacements
      
      if (this.currentPage) {
        url += '/' + this.currentPage;
      } else {
        url += '/empty';
      }
      if (this.searchTerm) {
        url += '/' + this.searchTerm;
      } else {
        url += '/empty';
      }
      if (this.selectedClient) {
        url += '/' + this.selectedClient;
      } else {
        url += '/empty';
      }
      if (this.sortColumn) {
        url += '/' + this.sortColumn;
      } else {
        url += '/empty';
      }
      if (this.sortDirection) {
        url += '/' + this.sortDirection;
      } else {
        url += '/empty';
      }
      // Return the final URL
      return url;
    },
    openPopup(affaire) {
      this.confirmationMessage = '';
      this.aff = affaire.naf;
      axios.post('https://www.simef.fr/espace-client/api/getAllUtilisateurs.php', {
      })
      .then(response => {
          this.users = response.data;
      })
      .catch(error => {
          console.log(error);
          
      });

       // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        affaire: affaire.naf
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data.split(',');
        console.log(this.utilisateursSelectionnes);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
          
      });

      this.popupOpen = true;
      this.popupArticle = affaire;
    },
    

    openPopupMasse() {
      this.confirmationMessage = '';

      axios.post('https://www.simef.fr/espace-client/api/getAllUtilisateurs.php', {
      })
      .then(response => {
          this.users = response.data;
      })
      .catch(error => {
          console.log(error);
          
      });

      // Envoyer les données d'inscription au serveur
      axios.post('https://www.simef.fr/espace-client/api/getUtilisateursRelies.php', {
        selectedItems: this.selectedItems,
      })
      .then(response => {
        this.utilisateursSelectionnes = response.data;

        console.log(response.data);
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
          

      });

      this.popupOpen2 = true;
    },

    closePopup() {
      this.popupOpen = false;
      this.popupArticle = null;
    },
    closePopupMasse() {
      this.popupOpen2 = false;
    },
    submit() {
      const tabUsers = Array.from(this.utilisateursSelectionnes);
      const emailString = tabUsers.join(',').replace(/^,/, ''); // Remove leading comma

      axios.post('https://www.simef.fr/espace-client/api/relierUtilisateur.php', {
        utilisateurs: emailString,
        affaire: this.aff
      })
      .then(response => {
          // Update the "relie" property of the corresponding "affaire" object
        const affaireToUpdate = this.affaires.find(affaire => affaire.naf === this.aff);
        if (affaireToUpdate) {
          affaireToUpdate.relie = response.data.success ? 1 : 0;
        }
        // Rediriger vers une page de confirmation d'inscription
        this.errorMEssage = response.data.error;
        if (Object.hasOwnProperty.call(response.data, 'success')) {
          this.confirmationMessage = response.data.success;
        }
        if (Object.hasOwnProperty.call(response.data, 'success1')) {
          this.confirmationMessage = response.data.success1;
        }

        this.getInfosAffaires();
        this.searchAffaires(this.currentPage);
        this.listActions = '';

      })
      .catch(error => {
        console.error(error);
        this.confirmationMessage = '';
        this.errorMEssage = "Une erreur est survenue";
      });
    },
    submit2() {
          const tabUsers = Array.from(this.utilisateursSelectionnes);
          const emailString = tabUsers.join(',').replace(/^,/, ''); // Remove leading comma

          axios.post('https://www.simef.fr/espace-client/api/relierUtilisateurs.php', {
            utilisateurs: emailString,
            selectedItems: this.selectedItems,
          })
            .then(response => {
              // Update the "relie" property of the corresponding "affaire" object
              this.selectedItems.forEach(selectedItem => {
                const affaireToUpdate = this.affaires.find(affaire => affaire.naf === selectedItem);
                if (affaireToUpdate) {
                  affaireToUpdate.relie = response.data.success ? 1 : 0;
                }
              });
              // Rediriger vers une page de confirmation d'inscription
              this.errorMEssage = response.data.error;
              if (Object.hasOwnProperty.call(response.data, 'success')) {
                this.confirmationMessage = response.data.success;
              }
              if (Object.hasOwnProperty.call(response.data, 'success1')) {
                this.confirmationMessage = response.data.success1;
              }

              this.getInfosAffaires();
              this.searchAffaires(this.currentPage);

              this.listActions = '';

            })
            .catch(error => {
              console.error(error);
              this.confirmationMessage = '';
              this.errorMEssage = "Une erreur est survenue";
            });
    },
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        // Reverse the sorting direction if the same column is clicked again
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Sort the clicked column in ascending order by default
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      // Call the searchArticles method with the current page and sorting parameters
      this.searchAffaires(this.currentPage);
    },
    getInfosAffaires() {
      axios.get('https://www.simef.fr/espace-client/api/getInfosAffaires.php')
      .then(response => {
        this.infosAffaires = response.data;


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx = document.getElementById('affecte').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires.nb_affaires_non_reliees, this.infosAffaires.nb_affaires_reliees],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['Non-reliées', 'Reliées'],

          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx, cfg);


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx1 = document.getElementById('retard').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg1 = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires.nb_affaires_en_retard, this.infosAffaires.nb_affaires_en_avance],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['En retard', 'Dans les temps']
          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx1, cfg1);


      })
      .catch(error => {
        console.error(error);
      });

      
    },
    getInfosAffairesProduction() {
      axios.post('https://www.simef.fr/espace-client/api/getInfosAffairesProduction.php', {
        utilisateur: this.loggedInEmail,
      })
      .then(response => {
        this.infosAffaires1 = response.data;


        // Sélectionnez le canvas sur lequel vous voulez afficher le graphique
        const ctx2 = document.getElementById('retardProduction').getContext('2d');
        // Créez un objet de configuration pour votre graphique
        const cfg2 = {
          type: 'doughnut',
          data: {
            datasets: [{
              data: [this.infosAffaires1.nb_affaires_en_retard, this.infosAffaires1.nb_affaires_en_avance],
              backgroundColor: [
                '#2b358d',
                '#1d1d20',
              ],
            }],
            labels: ['En retard', 'Dans les temps']
          }
        }
        // Créez et affichez le graphique en utilisant la configuration définie
        new Chart(ctx2, cfg2);


      })
      .catch(error => {
        console.error(error);
      });

      
    },
    toggleSelectAll() {
      if (this.selectAll) {
        // Cocher toutes les lignes
        this.selectedItems = this.affaires.map(affaire => affaire.naf);
      } else {
        // Désélectionner toutes les lignes
        this.selectedItems = [];
      }
    },
    handleActions() {
      if (this.selectedItems.length === 0) {
        alert("Veuillez sélectionner un ou plusieurs éléments.");
      } else {
        if (this.listActions === 'lier') {
          this.openPopupMasse();
        } else {
          this.solderAffaire2();
        }
      }
    },
    generateIcons(count) {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"/>
      </svg>`.repeat(count);
    },
    countEmails(emails) {
      if (!emails) return 0;
      return emails.split(',').length;
    },
    getDisponibiliteByNAF(naf) {
      const foundItem = this.dataDispo.find(item => item.naf === naf);
      return foundItem ? foundItem.disponibilite : null;
    }
    
  },
  
  beforeUnmount() {
    // Nettoyer les timeouts et requêtes en cours
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Composant détruit');
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $primary: #2346ad;
  .actionsAdmin {
    display: flex;
    align-items: center;
    @media screen and (max-width:992px) {
        flex-wrap: wrap;
        justify-content: center;
    }
    a {
      margin: 0px;
      margin-right: 15px;
      background: #2b358d;
      color: #fff !important;
      padding: 10px 20px;
      @media screen and (max-width:992px) {
        margin-right: 0px;
        margin-bottom: 15px;
      }
      svg {
        margin-right: 10px;
      }
    }
  }
  .prog {
    p {
      margin: 0px;
      margin-bottom: 2px;
      font-size: 0.7rem;
    }
  }
  .progress-bar {
    width: 100%; /* Ajustez la largeur selon votre mise en page */
    height: 8px; /* Ajustez la hauteur selon votre mise en page */
    background-color: #e0e0e0; /* Couleur de fond de la barre */
    span {
      background: #2b358d;
      height: 100%;
    }
  }
  
  
  
  .actions {
    color: #333!important;
  }
  .infosFiltersSoldee {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 15px;
    align-items: flex-end;
    @media screen and (max-width:992px) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .infos {
      display: flex;
      @media screen and (max-width:992px) {
        margin-bottom: 20px;
      }
      canvas {
        width: 180px!important;
        height: 180px!important;
      }
    }
    @media screen and (max-width:1250px) {
      justify-content: center;
      margin-bottom: 20px;
    }

  }
  .arrowSort {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    height: 100%;
    svg {
      height: 12px;
    }
  }
  th {
    cursor: pointer;
  }
  .expired {
    color: red;
  }
  .nonExpired {
    color: #c2e5f5;
  }
  .lie {
    color: #c2e5f5;
    svg {
      height: 16px;
      width: 16px;
      margin-right: 5px;
    }
  }
  .bulle {
    background-color: red;
    position: fixed;
    transform: translate(-50%,-50%);
    top: 50%;
    left: 50%;
  }
  .com {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 18px;
        widows: 18px;
      }
    }
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  .check {
    margin-right: 10px;
    font-weight: 500;
    @media screen and (max-width:992px) {
      margin-right: 0px;
      margin-top: 10px;
    }
  }
  .pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    width: 60%;
    @media screen and (max-width:992px) {
      width: 100%;
      margin-right: 10px;
    }
    span {
      cursor: pointer;
      margin: 3px 4px;
      font-size: 0.9rem;
      font-weight: 500;
    }
    .active {
      color: $primary;
      font-weight: 900;
    }
    select {
      color: #333!important;
      border: 0px;
      padding: 12px 15px;
      margin-right: 10px;
    }
  }

  table.affairesListe {
    width: 100%;
    tbody {
    
      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #2b358d!important;
      color: #fff!important;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #1d1d20;
    }
    th {
      color: #fff!important;
    }
       .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }

  .search {
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }
 

  .text-danger {
    color: rgb(255, 17, 17);
  }
  .search {
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 998!important;
  }
  
  .popup-content {
    max-width: 850px;
    padding: 40px 60px;
    max-height: 90%;
    background-color: #fff;
    border-radius: 0px;
    overflow: scroll;
    @media screen and (max-width:992px) {
      max-width: 90%;
      max-height: 90%;
    }

  }
  
  .popup-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    h2 {
      margin: 0px!important;
    }
  }
  
  .close-button {
    background: none!important;
    border: none!important;
    font-size: 30px!important;
    cursor: pointer!important;
    padding: 3px 7px!important;
    top: 4%!important;
    font-size: 1.5rem!important;
    transform: translateX(-100%)!important;
    left: 98%!important;
    margin: 0px !important;
    color: #2b358d;
    line-height: 1!important;
    &:hover {
      transform: none!important;
    }
  }
  .listPopup {
    max-width: 570px;
  }
  .containerList {
    /* width: 50%; */
    height: 155px;
    overflow-y: scroll;
    border: 0px;
    background: #fff;
    padding-top: 10px;
    padding: 20px;
    scrollbar-width: thin;
    scrollbar-color: #888888 #dddddd;
    .line {
      display: flex;
    }
    input {
      width: inherit;
      margin: 0px!important;
      margin-right: 10px!important;
    }
    .check {
      margin-top: 0px;
    }
  }
  .containerList::-webkit-scrollbar {
    width: 8px; /* Adjust the width of the scrollbar */
  }
  
  .containerList::-webkit-scrollbar-track {
    background-color: #dddddd; /* Color of the track */
  }
  
  .containerList::-webkit-scrollbar-thumb {
    background-color: #888888; /* Color of the thumb */
    border-radius: 4px; /* Adjust the border-radius of the thumb */
  }
  
  .containerList::-webkit-scrollbar-thumb:hover {
    background-color: #555555; /* Color of the thumb on hover */
  }
  .infosAffaireProd {
    text-align: left;
    @media screen and (max-width:992px) {
      text-align: center;
    }
    strong {
      font-weight: 900;
    }
    p {
      margin-bottom: 6px!important;
    }
  }
  .affaire-card-link {
    text-decoration: none;
    color: inherit;
  }
  .affaire-card {
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    min-height: 180px;
    position: relative;
    transition: box-shadow 0.2s;
    width: 100%;
    border: 1px solid #cbcbcb;
    border-radius: 0px;
    &:hover {
      box-shadow: 0 4px 16px rgba(43,53,141,0.15);
    }
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px!important;
    background: #2b358d;
    padding: 10px 20px;
    color: #fff;
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
  }
  .code-affaire {
    font-weight: 700;
    font-size: 1.1rem;
    color: #fff;
    .top {
      display: flex;
      gap: 10px;
    }
    .bottom {
      text-align: left;
    }
  }
  .card-body {
    display: flex;
    height: 100%;
    .content {
      width: 100%;
      padding: 20px;
    }
  }
  .card-title {
    margin-bottom: 10px;
    min-height: 70px;
    .desa1 {
      font-size: 1.1rem;
      font-weight: 700;
      color: #1d1d20;
    }
    .desa2, .desa3 {
      font-size: 0.9rem;
      color: #1d1d20;
      font-weight: 600;
    }
  }
  .card-infos {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
    flex-direction: column;
  }
  .info-chip {
    background: #f5f5f5;
    border-radius: 12px;
    padding: 4px 10px;
    font-size: 0.9rem;
    color: #1d1d20;
    display: flex;
    align-items: center;
    font-weight: 600;
    gap: 3px;
  }
  .progress-bar-affaire {
    width: 100%;
    margin-top: 8px;
    .progress-bg {
      width: 100%;
      height: 8px;
      background: #e8e8e8;
      border-radius: 8px;
      position: relative;
      overflow: hidden;
    }
    .progress-fill {
      height: 100%;
      border-radius: 8px;
      transition: width 0.3s;
    }
    .progress-label {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      font-size: 0.85rem;
      color: #222;
      font-weight: 700;
      pointer-events: none;
    }
  }
  .no-articles {
    grid-column: 1/-1;
    text-align: center;
    color: #888;
    font-size: 1.1rem;
    padding: 32px 0;
  }
  .sort-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    margin-bottom: 18px;
      gap: 8px;
    span {
      font-weight: 600;
      color: #2b358d;
      font-size: 1rem;
      svg {
        margin-left: 5px!important;
        margin-right: 0!important;
      }
    }
    .sort-btn {
      background: #2b358d;
      color: #fff;
      border: none;
      border-radius: 0px;
      padding: 6px 14px;
      font-weight: 600;
      font-size: 0.98rem;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-top: 0px!important;
      svg {
        path {
          fill: #fff;
        }
      }
      &:hover, &.active {
        background: #1d1d20;
      }
    }
  }
</style>
